import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithErrorHandling from '../../../api/apiConfig';

export const apiLoginSlice = createApi({
  reducerPath: 'loginApi', // name reducer of API slice
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/login`,
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const { useLoginMutation } = apiLoginSlice;